
import React from 'react';
import { TextField, FormControl, Grid, Typography, Card, CardContent, Button, IconButton, InputAdornment, useFormControl, FormHelperText, Box, RadioGroup, FormControlLabel, Radio, FormLabel } from '@mui/material';
import { UserRegisterT } from './RegisterScreen';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import NumberFormat, { NumberFormatProps } from 'react-number-format';
import NumberFormatCustom from '../../components/NumberFormatCustom';
import TextFieldValidate from '../../components/TextFieldValidate';
import { isEmail, validatePassword } from '../../utils/validator'
import { numberPhoneIsValid } from '../../utils/utilsT';
import Validator from 'jsonschema'
import colors from '../../constants/colors';
import GoogleMapAutoComplete from '../../components/MapBoxAutoComplete/GoogleMapAutoComplete';
import config from '../../constants/config';


var schema = {
    "id": "/formContactRegister",
    "type": "object",
    "properties": {
        "firstName": { "type": "string", "minLength": 1 },
        "lastName": { "type": "string", "minLength": 1 },
        "email": { "type": "string", "format": "email" },
        "phone": { "type": "string", "minLength": 8 },
        "password": { "type": "string", "minLength": 8 },
        "confirmPassword": { "type": "string", "minLength": 8 },
    },
    "required": ["firstName", 'lastName', 'email', 'phone']
};

export type IContactTabProps = {
    fields: UserRegisterT
    onChangeField(key: string, value: any): void
    nextTab(fields: UserRegisterT): void

}

const ContactTab: React.FC<IContactTabProps> = (props) => {

    const [showPassword, setShowPassword] = React.useState(false)
    const [showRePassword, setShowRePassword] = React.useState(false)

    const validatorRef = React.useRef(new Validator.Validator())



    const onChangeField = (key: string, value: any): void => {
        props.onChangeField(key, value)

    }

    const getValue = (key, fields) => {
        return fields[key] && fields[key] != null ? fields[key] : ""
    }


    const checkValidate = React.useCallback((params: UserRegisterT) => {
        console.log("checkValidate", validatorRef)
        if (!validatorRef || !validatorRef.current) {
            return false
        }

        const valid = validatorRef.current.validate(params, schema)
        if (!valid.valid || !numberPhoneIsValid(params.phone) || !checkValidatePassword(params)) {
            return false
        }
        return true
    }, [props.fields]);





    const checkValidatePassword = React.useCallback((params: UserRegisterT) => {
        if (params.password == "" || !validatePassword(params.password) || !matchPassword(params)) {
            return false
        }
        return true
    }, [props.fields]);


    const matchPassword = React.useCallback((params: UserRegisterT) => {
        if (params.password != params.confirmPassword) {
            return false
        }
        return true
    }, [props.fields]);


    const next = async (params: any): Promise<string> => {
        try {

            if (checkValidate(params)) {
                props.nextTab(params)
                return ""
            }
        } catch (error) {
            throw error
        }
    }

    return (
        <Box >

            {/* <CardContent style={{ justifyContent: "center", display: "flex" }}> */}

            <Grid container spacing={3} mt={2} xs={12}>
               
                <Grid item xs={12}>
                    <TextFieldValidate
                        // onValidate={(value) => {
                        //     return props.fields.firstName != "" ? true : false
                        // }}
                        name="firstName"
                        fullWidth required variant="standard" label="First Name"
                        value={`${getValue("firstName", props.fields)}`}
                        onChange={(event: any) => {
                            let value = event.target.value
                            onChangeField("firstName", value)
                        }}
                        onValidateError={(value) => {
                            return value == "" ? "Required" : ""
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextFieldValidate fullWidth required variant="standard"
                        name="lastName"
                        label="Last Name"
                        value={`${getValue("lastName", props.fields)}`}
                        onChange={(event: any) => {
                            let value = event.target.value
                            onChangeField("lastName", value)
                        }}
                        onValidateError={(value) => {
                            return value == "" ? "Required" : ""
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextFieldValidate fullWidth required variant="standard"
                        autoComplete={'off'}
                        name="email" label="Email" type="email"
                        value={`${getValue("email", props.fields)}`}
                        onChange={(event: any) => {
                            let value = event.target.value
                            onChangeField("email", value)
                        }}
                        onValidateError={(value) => {
                            if (value == "") {
                                return "Required"
                            }
                            if (!isEmail(value)) {
                                return "Invalid email"
                            }
                            return ""
                        }}
                    />
                </Grid>
                <Grid item xs={12}>


                    <TextFieldValidate
                        fullWidth
                        required
                        variant="standard"
                        label="Phone"
                        name="phone"
                        InputProps={{
                            inputComponent: NumberFormatCustom as any,
                            inputProps: {
                                format: "(###) ###-####",
                                mask: "_"
                            }
                        }}

                        value={`${getValue("phone", props.fields)}`}
                        onChange={(event: any) => {
                            let value = event.target.value
                            onChangeField("phone", value)
                        }}

                        onValidateError={(value) => {
                            if (value == "") {
                                return "Required"
                            }
                            if (!numberPhoneIsValid(value)) {
                                return "Invalid phone"
                            }
                            return ""
                        }}
                    />

                </Grid>

                <Grid item xs={12}>

                    <TextFieldValidate

                        fullWidth
                        required
                        label="Password"
                        variant="standard"
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            // disableUnderline: true,
                            endAdornment: (<InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={(event) => {
                                        event.preventDefault();
                                    }}
                                    onMouseDown={(e) => {
                                        setShowPassword(!showPassword)
                                    }}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>)
                        }}
                        className={`  `}
                        value={`${getValue("password", props.fields)}`}


                        onChange={(event: any) => {
                            let value = event.target.value
                            onChangeField("password", value)
                        }}

                        //    autoComplete={"false"}
                        onValidateError={(value) => {
                            if (value == "") {
                                return "Required"
                            }
                            if (!validatePassword(props.fields.password)) {
                                return "Your password must be at least 8 characters long, contain at least one number and have a mixture of uppercase and lowercase letters."
                            }
                            return ""
                        }}
                    />
                </Grid>

                <Grid item xs={12}>

                    <TextFieldValidate

                        fullWidth
                        required
                        label="Re-enter Password"
                        variant="standard"
                        type={showRePassword ? 'text' : 'password'}
                        value={`${getValue("confirmPassword", props.fields)}`}
                        InputProps={{
                            // disableUnderline: true,
                            endAdornment: (<InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={(event) => {
                                        event.preventDefault();
                                    }}
                                    onMouseDown={(e) => {

                                        setShowRePassword(!showRePassword)
                                    }}
                                    edge="end"
                                >
                                    {showRePassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>)
                        }}




                        onChange={(event: any) => {
                            let value = event.target.value
                            onChangeField("confirmPassword", value)
                        }}
                        onValidateError={(value) => {
                            if (value == "") {
                                return "Required "
                            }
                            // if (!validatePassword(props.fields.confirmPassword)) {
                            //     return "Your password must be at least 8 characters long, contain at least one number and have a mixture of uppercase and lowercase letters."
                            // }
                            if ((props.fields.password != "" && props.fields.confirmPassword != "" && !matchPassword(props.fields))) {
                                return "The passwords do not match."
                            }
                            return ""
                        }}
                    //    autoComplete={"false"}

                    />
                </Grid>


                <Grid item xs={12} >
                    <Button fullWidth
                        disabled={!checkValidate(props.fields)}
                        color="success" variant="contained"
                        onClick={() => {
                            next(props.fields)
                        }}
                    >
                        <Typography variant="button" color="#fff">Next</Typography>
                    </Button>
                </Grid>
            </Grid>


            {/* </CardContent> */}
        </Box>
    );
}

export default ContactTab
export { ContactTab }